import { defineMessages, type IntlShape, type MessageDescriptor } from "react-intl";

const callbackErrorMessages = defineMessages({
  metaError: {
    id: "instagramCallback.error.metaError",
    defaultMessage: "Meta did not authorize the Instagram connection. Please try again.",
  },
  invalidState: {
    id: "instagramCallback.error.invalidState",
    defaultMessage: "The Instagram connection link expired. Please start reconnect again.",
  },
  tokenExchangeFailed: {
    id: "instagramCallback.error.tokenExchangeFailed",
    defaultMessage:
      "Instagram did not return a usable access token. Please reconnect your Business or Creator account.",
  },
  accessTokenMissing: {
    id: "instagramCallback.error.accessTokenMissing",
    defaultMessage:
      "Instagram did not return an access token. Please reconnect your Business or Creator account.",
  },
  userIdMissing: {
    id: "instagramCallback.error.userIdMissing",
    defaultMessage:
      "Instagram did not identify the selected account. Please reconnect your Business or Creator account.",
  },
  permissionMissing: {
    id: "instagramCallback.error.permissionMissing",
    defaultMessage:
      "Instagram did not grant every required permission. Please reconnect and approve the requested access.",
  },
  profileLookupFailed: {
    id: "instagramCallback.error.profileLookupFailed",
    defaultMessage:
      "Instagram connected, but we could not read the account profile. Please try reconnecting.",
  },
  noInstagramAccount: {
    id: "instagramCallback.error.noInstagramAccount",
    defaultMessage:
      "No Instagram Business or Creator account was returned. Personal Instagram accounts cannot be connected.",
  },
  noFacebookPages: {
    id: "instagramCallback.error.noFacebookPages",
    defaultMessage:
      "Meta did not return any Facebook Pages. Try Instagram Login, or make sure your Meta account manages the Page linked to this Instagram account.",
  },
  noLinkedInstagramBusinessAccount: {
    id: "instagramCallback.error.noLinkedInstagramBusinessAccount",
    defaultMessage:
      "No linked Instagram Business account was found on your Meta Pages. Try Instagram Login, or check the account's Page connection in Meta.",
  },
  missingPageAccessToken: {
    id: "instagramCallback.error.missingPageAccessToken",
    defaultMessage:
      "Meta did not return the Page access needed for this Instagram account. Please try reconnecting via Meta Business.",
  },
  callbackFailed: {
    id: "instagramCallback.error.callbackFailed",
    defaultMessage: "We couldn't complete the Instagram connection. Please try again.",
  },
});

export const CALLBACK_ERROR_MESSAGE: Record<string, MessageDescriptor> = {
  meta_error: callbackErrorMessages.metaError,
  invalid_state: callbackErrorMessages.invalidState,
  instagram_token_exchange_failed: callbackErrorMessages.tokenExchangeFailed,
  instagram_access_token_missing: callbackErrorMessages.accessTokenMissing,
  instagram_user_id_missing: callbackErrorMessages.userIdMissing,
  instagram_permission_missing: callbackErrorMessages.permissionMissing,
  instagram_profile_lookup_failed: callbackErrorMessages.profileLookupFailed,
  no_instagram_account: callbackErrorMessages.noInstagramAccount,
  no_facebook_pages: callbackErrorMessages.noFacebookPages,
  no_linked_instagram_business_account: callbackErrorMessages.noLinkedInstagramBusinessAccount,
  missing_page_access_token: callbackErrorMessages.missingPageAccessToken,
  callback_failed: callbackErrorMessages.callbackFailed,
};

const CALLBACK_FAILED_MESSAGE = callbackErrorMessages.callbackFailed;

export const getInstagramCallbackErrorMessage = (reason: string | null, intl: IntlShape): string =>
  intl.formatMessage(
    reason ? (CALLBACK_ERROR_MESSAGE[reason] ?? CALLBACK_FAILED_MESSAGE) : CALLBACK_FAILED_MESSAGE,
  );
